// TODO: move all settings routes under /src/modules/Settings

export const PATH_SETTINGS = "/member/settings";
